import baseSidebarTheme from "../baseSidebarTheme";
import { colors } from "../../../ui/colors";

/**
 * Proposal 2
 * Minimal, calm, low visual noise
 */
const proposal2 = {
  ...baseSidebarTheme,

  /* =========================
   * DRAWER
   * ========================= */
  Drawer: {
    ...baseSidebarTheme.Drawer,

    background: "var(--fx-surface-base, #FFFFFF)",
    border: "none",
    shadow: "none",

  },

  /* =========================
   * PAGE ITEM (MAIN NAV)
   * ========================= */
  PageItem: {
    ...baseSidebarTheme.PageItem,

    background: {
      default: "transparent",
      hover: colors.gray[100],
      active: colors.gray[100],
    },

    text: {
      default: colors.gray.base,
      active: colors.gray.base,
    },

    icon: {
      default: colors.gray.base,
      active: colors.gray.base,
    },

    shadow: {
      default: "none",
      hover: "none",
      active: "none",
    },

    indicator: {
      width: 0,           // remove left accent bar
      gradient: "none",
    },
  },

  /* =========================
   * TOOLKIT SECTION
   * ========================= */
  ToolkitSection: {
    ...baseSidebarTheme.ToolkitSection,

    background: "var(--fx-surface-base, #FFFFFF)",
    
  },

  /* =========================
   * TOOLKIT ITEM
   * ========================= */
  ToolkitItem: {
    border: `1px solid ${colors.gray[100]}`,
    borderBottom: `1px solid ${colors.orange[100]}`,
    shadow: {
      hover: "none",
    },
    lift: {
      hover: "0px",
    },
  },

  /* =========================
   * TOOLKIT ICON
   * ========================= */
  ToolkitIcon: {
    ...baseSidebarTheme.ToolkitIcon,

    background: "var(--fx-surface-base, #FFFFFF)",
    border: "1px solid rgba(var(--fx-surface-textrgb, 15, 23, 42), .04)",
    shadow: "none",

    icon: {
      default: colors.gray[300],
      hover: colors.orange[400], // no color pop on hover
    },
  },
};

export default proposal2;
